import './EnterInstanceName.css';
import { useState } from 'react';

const EnterInstanceName = ({ clientInstanceError, redirectRoute}) => {
    const [ instanceName, setInstanceName ] = useState('');

    const checkValidInstance = () => {
        if(instanceName.trim()) {
            window.location.href = `${redirectRoute}${instanceName.trim()}`;
        };
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        checkValidInstance();
    };

    return (
        <div className="client-instance-enter-name">
            <div className="instance-card">
                <div className="instance-header">
                    <h1>Access Your Instance</h1>
                    <p>Enter your instance name to continue</p>
                </div>
                <form onSubmit={handleSubmit} className="instance-form">
                    <div className="form-group">
                        <label htmlFor="instanceName">Instance Name</label>
                        <input
                            type="text"
                            id="instanceName"
                            value={instanceName}
                            onChange={(e) => setInstanceName(e.target.value)}
                            placeholder="yourInstanceName"
                            required
                        />
                    </div>
                    {clientInstanceError && <div className="error-message">{clientInstanceError}</div>}
                    <button type="submit" className="btn-primary">
                        Continue
                    </button>
                </form>
            </div>
        </div>
    );
};

export default EnterInstanceName;